import React from 'react'

export default () => (
  <>
  <p>
    A driven computer science student studying at the University of Bristol, 
    with experience working with low - high level languages accross a range of domains.
  </p>

<br></br>
  <p>
    Experience working with Elixir, the Web and the Internet of Things.
  </p>

  </>
)